import homePage from './homePage';
import identity from './identity';
import permissions from './permissions';
import audit from './audit';
import personCenter from './personCenter';
import comprehensiveQuery from './comprehensiveQuery';
import home from './home';
import systemSet from './systemSet';
import report from './report';
import setTimeDown from './setTimeDown';
import monthlyStatementExport from './monthlyStatementExport';

const main = {
    login: '/sys/login',
    loginOut: '/basic/logout',
    code: '/datatype/list',
    otherMenu: '/basic/platforms/getAll',
    getslefMenu: '/basic/permissions/getMenu', // 获取自己的菜单，权限判断
    queryMessagePage: '/basic/messages/queryMessagePage', // 获取系统通知
    queryBacklogPage: '/basic/messages/queryBacklogPage', // 获取代办事项
    clearMes: '/basic/messages/clear', // 清除代办事项和通知
    basicdayreport: '/basic/mpp/basicdayreport', // 清除代办事项和通知
    exportdayreport: '/basic/mpp/exportdayreport', // 清除代办事项和通知
    queryIndex: '/basic/statements/queryIndex', // 获取首页dts地址
    fieldlist: '/basic/field/list'
};
// const deepMap = (Obj, prefix) => {
//     for (let key in Obj) {
//         Obj[key] = Obj[key] && Obj[key].toString() === '[object Object]' ? deepMap(Obj[key], prefix) : (Obj[key] = prefix + Obj[key]);
//     }
//     return Obj;
// };
export default {
    home,
    homePage,
    audit,
    permissions,
    identity,
    report,
    main,
    personCenter,
    comprehensiveQuery,
    systemSet,
    setTimeDown,
    monthlyStatementExport
};
